import {
  mapSubscriptionToIncomingRenewal,
  MembershipIncomingRenewalPayload,
} from '@models/membership/MembershipIncomingRenewal'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_INCOMING_RENEWALS_URL } from '@utils/urls'

// The endpoint serves the shared subscription resource, so the rows are
// flattened here: everything downstream (store, table, SBRM view) keeps reading
// the flat `MembershipIncomingRenewal`.
const fetchMembershipIncomingRenewals = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipIncomingRenewalPayload[]>(
    MEMBERSHIP_INCOMING_RENEWALS_URL,
    params
  ).then((response) => ({
    ...response,
    // `?? []`: an empty payload must land on the table's empty state, not throw
    // its way into the slice's error state.
    data: (response.data ?? []).map(mapSubscriptionToIncomingRenewal),
  }))

export { fetchMembershipIncomingRenewals }
